import { Checkbox, InfoBlock, RadioButtons, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect } from "react";
import { WizarContext, juniorCommunicationInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { initialWizardFormState } from "contexts/WizardContext";

const CommunicationInfo = ({ errors, setErrors }) => {
  let magazines = [
    { value: "TEC21", label: "TEC21" },
    { value: "TRACES", label: "TRACES" },
    { value: "ARCHI", label: "ARCHI" },
    { value: "ARCHI + TEC21", label: "ARCHI + TEC21" },
    { value: "ARCHI + TRACES", label: "ARCHI + TRACES" },
    { value: "", label: "Keine" },
  ];
  const translate = useTranslator();
  const { state, dispatch } = useContext(WizarContext);
  let communicationInfo = state.junior.communicationInfo;
  let changState = useCallback((payload) => dispatch(juniorCommunicationInfoActionCreator(payload)), [dispatch]);
  const { user } = useContext(GlobalContext);
  const userId = user.siaId;

  const setUserSession = (obj) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = {
        ...data,
        junior: { ...(data.junior || {}), communicationInfo: { ...(data?.junior?.communicationInfo || {}), ...obj } },
      };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };

  useEffect(() => {
    if (userId) {
      pgAdapter.getWizardSession(({ data }) => {
        const defaultCommunicationInfo = { ...initialWizardFormState.junior.communicationInfo };
        const { communicationInfo } = data?.junior || {};
        const {
          selectedMagazine,
          magazineFormatEpaper,
          magazineFormatPrinted,
          newsLetterGerman,
          newsLetterFrench,
          siaInformNewsletterDe,
          siaInformNewsletterFr,
          siaInformNewsletterIt,
        } = communicationInfo || defaultCommunicationInfo;
        changState({
          selectedMagazine: selectedMagazine || "",
          magazineFormatEpaper: magazineFormatEpaper || false,
          magazineFormatPrinted: magazineFormatPrinted || false,
          newsLetterGerman: newsLetterGerman || false,
          newsLetterFrench: newsLetterFrench || false,
          siaInformNewsletterDe,
          siaInformNewsletterFr,
          siaInformNewsletterIt,
        });
      });
    }
  }, [userId, changState]);

  return (
    <div className="communication-info-page">
      <p className="">{translate("wizard.form.single.communication.info")}</p>
      <div className="sia-margin-03-top">
        <InfoBlock loose>
          <span className="label">{translate("wizard.form.single.communication.magazins.label")}</span>
          <div className="sia-margin-01-top communication-magazine">
            <RadioButtons
              name={"communication-page-radio"}
              items={magazines}
              selectedValue={communicationInfo.selectedMagazine}
              onChange={(value) => {
                changState({ selectedMagazine: value });
                setUserSession({ selectedMagazine: value });
              }}
            />
            <div>
              <Checkbox
                id={"communication-page-ePaper"}
                label={translate("E-paper")}
                value={communicationInfo.magazineFormatEpaper}
                onChange={(event, value) => {
                  changState({ magazineFormatEpaper: value });
                  setUserSession({ magazineFormatEpaper: value });
                }}
              />
              <Checkbox
                id={"communication-page-printed"}
                label={"gedruckt"}
                value={communicationInfo.magazineFormatPrinted}
                onChange={(event, value) => {
                  changState({ magazineFormatPrinted: value });
                  setUserSession({ magazineFormatPrinted: value });
                }}
              />
            </div>
          </div>
          <span className="label sia-margin-03-top">{translate("wizard.form.single.communication.newsletter.label")}</span>
          <Checkbox
            id={"communication-page-nsd"}
            label={translate("wizard.form.single.communication.newsletter.german.label")}
            value={communicationInfo.newsLetterGerman}
            onChange={(event, value) => {
              changState({ newsLetterGerman: value });
              setUserSession({ newsLetterGerman: value });
            }}
          />
          <Checkbox
            id={"communication-page-nsf"}
            label={translate("wizard.form.single.communication.newsletter.french.label")}
            value={communicationInfo.newsLetterFrench}
            onChange={(event, value) => {
              changState({ newsLetterFrench: value });
              setUserSession({ newsLetterFrench: value });
            }}
          />
          <Checkbox
            id={"communication-page-insd"}
            label={translate("wizard.form.single.communication.inform-newsletter.german.label")}
            value={communicationInfo.siaInformNewsletterDe}
            onChange={(event, value) => {
              changState({ siaInformNewsletterDe: value });
              setUserSession({ siaInformNewsletterDe: value });
            }}
          />
          <Checkbox
            id={"communication-page-insf"}
            label={translate("wizard.form.single.communication.inform-newsletter.french.label")}
            value={communicationInfo.siaInformNewsletterFr}
            onChange={(event, value) => {
              changState({ siaInformNewsletterFr: value });
              setUserSession({ siaInformNewsletterFr: value });
            }}
          />
          <Checkbox
            id={"communication-page-insi"}
            label={translate("wizard.form.single.communication.inform-newsletter.italian.label")}
            value={communicationInfo.siaInformNewsletterIt}
            onChange={(event, value) => {
              changState({ siaInformNewsletterIt: value });
              setUserSession({ siaInformNewsletterIt: value });
            }}
          />
        </InfoBlock>
      </div>
    </div>
  );
};

export default CommunicationInfo;
